import '../../../styles/restScreens.css';
import React, { useState } from 'react';
import Button3D from '../../ui/Button3D';
import Modal3D from '../../ui/Modal3D';
import EscapeGuard from './EscapeGuard';

// Create, rename and delete the event's groups. Deleting a group never deletes a guest: they simply have no group afterwards.
export default function GuestGroupsPopup({ groups = [], guests = [], busy = false, error = '', onCreate, onRename, onDelete, onClose }) {
    const [name, setName] = useState('');
    const [editing, setEditing] = useState(null);   // { id, name }
    const [confirming, setConfirming] = useState(null);
    const countIn = (groupId) => guests.filter((guest) => guest.group_id === groupId).length;
    const input = 'min-h-[44px] lg:[@media(pointer:fine)]:min-h-[34px] w-full rounded-lg border border-[#64748B] bg-[#0B1220] px-2 text-white';

    return (
        <EscapeGuard>
            <Modal3D
                title="Groups"
                subtitle="Family, friends, vendors: any way you want to sort your guests."
                testId="guest-groups-popup"
                onClose={onClose}
                data-m6-layout="modals"
                data-m6-component="EventGuestGroupsPopup"
                actions={<Button3D variant="go" onClick={onClose}>Done</Button3D>}
            >
                <form className="flex flex-wrap items-end gap-2" onSubmit={(event) => { event.preventDefault(); if (name.trim()) { onCreate(name.trim()); setName(''); } }}>
                    <div className="min-w-0 grow">
                        <label htmlFor="new-group" className="mb-1 block text-xs font-bold uppercase tracking-wide">New group</label>
                        <input id="new-group" className={input} value={name} onChange={(event) => setName(event.target.value)} maxLength={80} autoComplete="off" />
                    </div>
                    <Button3D type="submit" variant="pill" disabled={busy || !name.trim()}>Add group</Button3D>
                </form>
                {error && <p className="ia-resv-error" role="alert">{error}</p>}
                {groups.length === 0 ? (
                    <p className="mt-3 text-sm">No groups yet.</p>
                ) : (
                    <ul className="mt-3 space-y-2" aria-label="Groups">
                        {groups.map((group) => (
                            <li key={group.id} className="rounded-lg border border-[#3B4D73] p-2" data-testid="group-row">
                                {editing?.id === group.id ? (
                                    <form className="flex flex-wrap items-center gap-2" onSubmit={(event) => { event.preventDefault(); if (editing.name.trim()) { onRename(group.id, editing.name.trim()); setEditing(null); } }}>
                                        <input aria-label={`New name for ${group.name}`} className={`${input} grow`} value={editing.name} onChange={(event) => setEditing({ id: group.id, name: event.target.value })} maxLength={80} autoComplete="off" />
                                        <Button3D type="submit" variant="pill" disabled={busy || !editing.name.trim()}>Save</Button3D>
                                        <Button3D variant="pill" onClick={() => setEditing(null)}>Cancel</Button3D>
                                    </form>
                                ) : confirming === group.id ? (
                                    <div role="alert" className="space-y-2">
                                        <p className="text-sm">Delete “{group.name}”? Its {countIn(group.id)} {countIn(group.id) === 1 ? 'guest stays' : 'guests stay'} on the list, just without a group.</p>
                                        <div className="flex flex-wrap gap-2">
                                            <Button3D variant="pill" onClick={() => setConfirming(null)}>Keep group</Button3D>
                                            <Button3D variant="pill" onClick={() => { onDelete(group.id); setConfirming(null); }} disabled={busy}>Delete group</Button3D>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex flex-wrap items-center justify-between gap-2">
                                        <div className="min-w-0 break-words font-semibold">{group.name} <span className="font-normal">· {countIn(group.id)} {countIn(group.id) === 1 ? 'guest' : 'guests'}</span></div>
                                        <div className="flex gap-2">
                                            <Button3D variant="pill" onClick={() => setEditing({ id: group.id, name: group.name })} aria-label={`Rename ${group.name}`}>Rename</Button3D>
                                            <Button3D variant="pill" onClick={() => setConfirming(group.id)} aria-label={`Delete ${group.name}`}>Delete</Button3D>
                                        </div>
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </Modal3D>
        </EscapeGuard>
    );
}
